document.addEventListener('DOMContentLoaded', function () {

  // ─── CROSSHAIR CURSOR ───
  const dot = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');
  let mx = 0, my = 0, rx = 0, ry = 0;

  document.addEventListener('mousemove', e => {
    mx = e.clientX; my = e.clientY;
    dot.style.transform = `translate(${mx - 3}px, ${my - 3}px)`;
  });

  function animateRing() {
    rx += (mx - rx) * 0.1;
    ry += (my - ry) * 0.1;
    ring.style.transform = `translate(${rx - 20}px, ${ry - 20}px)`;
    requestAnimationFrame(animateRing);
  }
  animateRing();

  // Crosshair grows on clickable elements
  document.querySelectorAll('a, button, .product-card, .gallery-item').forEach(el => {
    el.addEventListener('mouseenter', () => {
      ring.style.width = '56px';
      ring.style.height = '56px';
      ring.style.opacity = '1';
    });
    el.addEventListener('mouseleave', () => {
      ring.style.width = '40px';
      ring.style.height = '40px';
      ring.style.opacity = '0.85';
    });
  });

  // Click flash
  document.addEventListener('click', () => {
    dot.style.transform += ' scale(2.5)';
    dot.style.opacity = '0.5';
    setTimeout(() => { dot.style.opacity = '1'; }, 120);
  });

  // ─── SCROLL REVEAL ───
  const observer = new IntersectionObserver(entries => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 70);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  // ─── NAV SCROLL ───
  const nav = document.querySelector('nav.rd-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.padding = window.scrollY > 50
        ? '13px 48px' : '20px 48px';
    }, { passive: true });
  }

  // ─── EMAIL FORM ───
  const btn = document.querySelector('.email-submit');
  if (btn) {
    btn.addEventListener('click', () => {
      const inp = document.querySelector('.email-input');
      if (inp && inp.value.includes('@')) {
        btn.textContent = '✓ LISTO';
        btn.style.background = '#1a5c1a';
        inp.value = '';
        setTimeout(() => {
          btn.textContent = 'SUSCRIBIRSE';
          btn.style.background = '';
        }, 3000);
      }
    });
  }

  // ─── CART COUNT ───
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const cartBtn = document.querySelector('.nav-cart');
      if (cartBtn && cart.item_count > 0) {
        cartBtn.textContent = `CARRITO (${cart.item_count})`;
      }
    })
    .catch(() => {});
});
